<template>
  <div class="content">
    <div class="content-header">
      <ContentBox title="财务管理" class="content-box">
        <div class="header-box">
          <div v-permission="'balance'">
            <p class="header-box-text">
              <span>账户余额</span>
              <el-tooltip class="item" effect="light" placement="top-start">
                <i
                  class="el-icon-cc-info-circle"
                  style="width:14px;height:14px;color:rgba(0,0,0,0.45);"
                ></i>
                <div slot="content">充值金额优先抵扣已用信用额度</div>
              </el-tooltip>
            </p>
            <p class="header-box-num" >{{toLocaleString(financialInfo.balance || 0)}}&nbsp;元</p>
          </div>
          <div v-permission="'residueCredit'">
            <p class="header-box-text">
              <span>剩余信用额度</span>
               <el-tooltip class="item" effect="light" placement="top-start">
              <i
                class="el-icon-cc-info-circle"
                style="width:14px;height:14px;color:rgba(0,0,0,0.45);"
              ></i>
               <div slot="content">剩余信用额度</div>
               </el-tooltip>
            </p>
            <p class="header-box-num" >{{toLocaleString(financialInfo.residueCredit || 0)}}&nbsp;元</p>
          </div>
          <div v-permission="'freezeBalance'">
            <p class="header-box-text" >
              <span>冻结金额</span>
              <el-tooltip class="item" effect="light" placement="top-start">
              <i
                class="el-icon-cc-info-circle"
                style="width:14px;height:14px;color:rgba(0,0,0,0.45);"
              ></i>
              <div slot="content">冻结金额</div>
              </el-tooltip>
            </p>
            <p class="header-box-num" >{{toLocaleString(financialInfo.freezeBalance || 0)}}&nbsp;元</p>
          </div>
        </div>
      </ContentBox>
      <div>
        <el-tabs v-model="activeName" :class="isMounted ? 'table-tabs': 'table-tabs table-tabs--before-mount'">
        <el-tab-pane label="交易明细" name="trad" v-if="showTrad">
            <Trad v-if="activeName === 'trad'" ></Trad>
          </el-tab-pane>
          <el-tab-pane label="信用额度记录" name="financial" v-if="showCredit">
            <Credit v-if="activeName === 'financial'"></Credit>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Trad from './FinancialTrad'
import Credit from './FinancialCredit'
export default {
  components: {
    Trad,
    Credit
  },
  data() {
    return {
      activeName: this.$appState.$get('permissions')['trade:list'] ? 'trad' : 'financial',
      financialInfo: {
        balance: 0,
        fixedCredit: 0,
        freezeBalance: 0,
        residueCredit: 0
      },
      showTrad: this.$appState.$get('permissions')['trade:list'],
      showCredit: this.$appState.$get('permissions')['credit:list'],
      isMounted: false
    }
  },
  methods: {
    getFetchData() {
      this.$service.getAccountInfo().then(data => {
        this.financialInfo = data || {}
      })
    },
    toLocaleString(number) {
      return number.toLocaleString('en-IN', { minimumFractionDigits: 2 })
    }
  },
  mounted() {
    this.isMounted = true
  },
  created() {
    this.getFetchData()
  }
}
</script>
<style lang="stylus" scoped>
.content-box {
  margin-bottom: 0;

  >>>.content-box__header {
    height: 72px;
  }

  >>>.title {
    width: 80px;
    height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    padding 24px 0 20px 32px
  }
}

.header-box {
  display: flex;
}

.header-box div {
  width: 20%;
  padding: 0 20px 30px 20px;
}

.header-box div:nth-child(1) {
  padding-left: 0;
}

// .header-box div:nth-child(1), .header-box div:nth-child(2) {
//   border-right: 1px solid #f2f2f2;
// }
.header-box-text {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.header-box-text span {
  font-size: 14px;
  font-weight: 400;
  height: 22px;
  line-height 22px
  color rgba(0,0,0,0.45);
}
.header-box-text i {
  font-size 13px
  margin-left 8px
}

.header-box-num {
  font-size: 24px;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  color:rgba(0,0,0,0.85);
  margin-top 5px
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-tabs {
  >>>.el-tabs__header {
    background-color: #fff;
    padding-left: 32px;
    margin 0 0 16px
  }

  >>>.el-tabs__nav-wrap:after {
    content: none;
  }
    >>>.el-tabs__item {
    font-size 16px
    height: 33px;
    line-height: 1;
  }
}
p {
  margin: 0;
}

>>>.content-box__main {
  margin: 16px 32px 0;
}
>>>.el-form--inline .el-form-item
  margin-right 16px
</style>
